<div class="notifications-recipients-wrapper">
  <span class="title">{{
    '+SETTINGS.NOTIFICATION_SETTINGS_COMPANY_NOTIFICATIONS' | translate
  }}</span>
  <span class="description">{{
    '+SETTINGS.NOTIFICATION_SETTINGS_COMPANY_NOTIFICATIONS_DESCRIPTION' | translate
  }}</span>
  <div>
    <div data-at-notification-recipients-list class="flex flex-col">
      <ng-container [ngSwitch]="notificationsStore.notificationRecipientsStatus$ | async">
        <ng-container *ngSwitchCase="NotificationRecipientsStatus.Default">
          <vi-loader data-at-loader [isLoading]="true"></vi-loader>
        </ng-container>

        <ng-container *ngSwitchCase="NotificationRecipientsStatus.Loading">
          <vi-loader data-at-loader [isLoading]="true"></vi-loader>
        </ng-container>

        <ng-container *ngSwitchCase="NotificationRecipientsStatus.LoadedNoRecipients">
          <app-banner type="info">{{
            '+SETTINGS.NOTIFICATION_SETTINGS_COMPANY_NOTIFICATIONS_NO_RECIPIENTS' | translate
          }}</app-banner>
        </ng-container>

        <ng-container *ngSwitchCase="NotificationRecipientsStatus.ErrorCentralEmailRequired">
          <app-banner type="warning">{{
            '+SETTINGS.NOTIFICATION_SETTINGS_COMPANY_NOTIFICATIONS_CENTRAL_EMAIL_REQUIRED_ERROR'
              | translate
          }}</app-banner>
        </ng-container>

        <ng-container *ngSwitchCase="NotificationRecipientsStatus.Error">
          <app-banner type="error">{{
            '+SETTINGS.NOTIFICATION_SETTINGS_COMPANY_NOTIFICATIONS_NO_RECIPIENTS_ERROR' | translate
          }}</app-banner>
        </ng-container>

        <ng-container *ngSwitchCase="NotificationRecipientsStatus.Loaded">
          <div data-at-body class="body flex flex-col flex-auto">
            <div class="recipient-entry" *ngFor="let recipient of processedRecipients">
              <div class="recipient-details">
                <span class="recipient-email">{{ recipient.email }}</span>
                <span class="recipient-identity"
                  >{{ recipient.firstName }} {{ recipient.lastName }}</span
                >
              </div>
              <div>
                <mat-slide-toggle
                  gtm="onToggle"
                  gtmAction="Switch on off notification"
                  gtmCategory="Notifications"
                  [checked]="recipient.isActive"
                  (change)="onToggleChanged($event, recipient)"
                >
                </mat-slide-toggle>
              </div>
            </div>
          </div>
          <div data-at-foot class="foot flex flex-col flex-auto">
            <mat-paginator
              data-at-paginator
              [length]="sourcedRecipients.length"
              [pageIndex]="pagination.page"
              [pageSize]="pagination.pageSize"
              (page)="onPageChange($event)"
            >
            </mat-paginator>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
